import _ from 'lodash'

import type { IRecord } from '@/interfaces'
// import { debounce } from 'lodash'

// export const debounceSearch = debounce(
// 	(searchTerm: string, records: IRecord[], callback: (results: IRecord[]) => void) => {
// 		const filteredRecords = searchRecords(searchTerm, records) as IRecord[]
// 		callback(filteredRecords)
// 	},
// 	200,
// 	{ leading: true, trailing: true }
// )

export function searchRecords(searchTerm: string, records: IRecord[]): IRecord[] {
	if (!searchTerm) {
		return records
	}

	const searchTerms = searchTerm
		.toLowerCase()
		.split('&')
		.map((term) => term.trim())

	return records.filter((record) => {
		const recordValues = Object.values(record)
			// .filter((value) => typeof value === 'string')
			.map((value) => String(value).toLowerCase())

		// Check if all search terms match any of the record values
		return searchTerms.every((term) => recordValues.some((value) => value.includes(term)))
	})
}

export function orderRecords(sortKey: string, reverse: boolean, recordSet: IRecord[]): IRecord[] {
	if (!recordSet.length) {
		return recordSet
	}
	const sampleValue = recordSet[0][sortKey]
	const isNumber = typeof sampleValue === 'number'
	const isDate = sampleValue instanceof Date
	// if it's not a number or date, assume it's a string
	const sortOrder = reverse ? 'desc' : 'asc'

	const sortFn = (record: IRecord) => {
		const value = record[sortKey]
		if (isNumber) {
			return value
		}
		if (isDate) {
			return (value as Date).getTime()
		}
		// Fallback: assume string
		return _.toLower(value as string)
	}
	return _.orderBy(recordSet, [sortFn], [sortOrder])
}

/**
 * Sort the record set based on multiple sort criteria.
 *
 * @param sortCriteria - An array of objects with { key, reverse }.
 * @param recordSet - The records to sort.
 * @returns The sorted records.
 */
export function orderRecordsMulti(sortCriteria: { key: string; reverse: boolean }[], recordSet: IRecord[]): IRecord[] {
	// If no records or no criteria, return unsorted records.
	if (!recordSet.length || !sortCriteria.length) {
		// console.warn('No records or sort criteria provided. Returning unsorted records.')
		return recordSet
	}

	// Build an array of iteratees – one per sort criteria.
	const iteratees = sortCriteria.map((criteria) => {
		// Use the first record to determine the value type.
		const sampleValue = recordSet[0][criteria.key]
		const isNumber = typeof sampleValue === 'number'
		const isDate = sampleValue instanceof Date

		return (record: IRecord) => {
			const value = record[criteria.key]
			if (isNumber) {
				return value
			}
			if (isDate) {
				return (value as Date).getTime()
			}
			// Otherwise, assume string
			return _.toLower(String(value))
		}
	})
	// Build an array of order strings ("asc" or "desc") for each criterion.
	const orders = sortCriteria.map((criteria) => (criteria.reverse ? 'desc' : 'asc'))

	return _.orderBy(recordSet, iteratees, orders)
}
